// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__326Uy","sendOtp":"AuthorizeToLogin_sendOtp__3xJLF"};